module.exports = __webpack_public_path__ + "img/Number=57.26dc4ccf.png";